import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportPendingActivitiesPerProfessionalPdfUseCaseInterface } from 'domain/usecases';

export class RemoteExportPendingActivitiesPerProfessionalPdf
  implements ExportPendingActivitiesPerProfessionalPdfUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportPendingActivitiesPerProfessionalPdfUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportPendingActivitiesPerProfessionalPdfUseCaseInterface.Params,
  ): Promise<ExportPendingActivitiesPerProfessionalPdfUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
